import { ObjectId } from "bson";

export enum OrderType {
    RequestAdvertisingQuote = "request_advertising_quote",
    RequestSubscriptionQuote = "request_subscription_quote",
    SpaceInsight2020 = "space_insight_2020",
    Report = "report",
}

export enum OrderStatus {
    InProcess = "in_process",
    RequestReceived = "request_received",
    QuoteSent = "quote_sent",
    Shipped = "shipped",
    Delivered = "delivered",
    Completed = "completed",
}

export interface Order {
    orderid: string;
    type: OrderType;
    status: OrderStatus;
    userId?: ObjectId;
    createdAt: Date;
}
